import {Breadcrumb, Layout, Menu, Dropdown, Button} from 'antd';
import {LogoutOutlined, UserOutlined, ZhihuOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useUser} from "../../../Context/UserContext";
import {useEffect} from "react";
import ApiService from "../../../Service/ApiService";
import {LocalStorageService} from "../../../Service/LocalStorageService";
import {useHistory} from "react-router-dom";

const {SubMenu} = Menu;

export default function ProfileDropdown()
{
    const {t} = useTranslation();
    const {signOut, setUser, user} = useUser();
    const history = useHistory();

    const onClick = (item) => {
        if(item.key === 'logout')
        {
            signOut()
        }
        else if(['en', 'tr'].includes(item.key))
        {
            LocalStorageService.setLanguage(item.key)
            window.location.reload()
        }
        else if(item.key === 'profile') {
            history.push('/app/user/profile')
        }
        else if(item.key === 'dashboard') {
            history.push('/app/user/dashboard')
        }
        else if(item.key === 'admin-dashboard') {
            history.push('/app/admin/dashboard')
        }
    }

    const getUser = async () => {
        const response = await ApiService.User.Information();
        if(response.success)
        {
            setUser(response.data)
        }
    }

    useEffect(() => {
        ApiService.setLogout(signOut)
    }, [])

    useEffect(() => {
        getUser()
    }, [])

    const menu = (
        <Menu onClick={onClick}>
            <Menu.Item key={'profile'}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <img src={'/icons/Profile.svg'} width={14} height={14} style={{fill: '#000'}}/>
                    <span>Profile</span>
                </div>
            </Menu.Item>
            <Menu.Item key={'dashboard'}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <img src={'/icons/User-Dashboard.svg'} width={14} height={14} style={{fill: '#000'}}/>
                    <span>Dashboard</span>
                </div>
            </Menu.Item>
            {
                user?.data?.isAdmin && (
                    <Menu.Item key={'admin-dashboard'}>
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <img src={'/icons/Admin-Dashboard.svg'} width={14} height={14} style={{fill: '#000'}}/>
                            <span>Admin Dashboard</span>
                        </div>
                    </Menu.Item>
                )
            }
            {/*<SubMenu icon={<ZhihuOutlined />} key={'languages'} title={'Language'}>*/}
            {/*    <Menu.Item key="en">*/}
            {/*        English*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item key="tr">*/}
            {/*        Türkçe*/}
            {/*    </Menu.Item>*/}
            {/*</SubMenu>*/}
            <Menu.Item key="logout">
                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <img src={'/icons/Logout.svg'} width={14} height={14} style={{fill: '#000'}}/>
                    <span>{t('Logout')}</span>
                </div>
            </Menu.Item>
        </Menu>
    );

    return (
        <div style={{marginRight: 16}}>
            <Dropdown overlay={menu} placement="bottomLeft" icon={<UserOutlined />}>
                <Button style={{backgroundColor: '#ffffff00', color: '#fff'}}>
                    <UserOutlined />
                    {user && `${user.data.name}`}
                </Button>
            </Dropdown>
        </div>
    )
}
